import {
  CancellationsTab as CancellationsTabBase,
  FLAGGED_CANCELLATION_POLICY_SCOPE,
} from 'components/BuildingDetailTabs/BuildingCancellationsTab';

export const CancellationsTab = (props) => (
  <CancellationsTabBase {...props} policyScope={FLAGGED_CANCELLATION_POLICY_SCOPE.ROLE_BUILDING} />
);
